// AZERTY
export const AZERTY = [
        { key: 100, value: 'a', x: 0, y: 0 },
        { key: 102, value: 'z', x: 1, y: 0 },
        { key: 103, value: 'e', x: 2, y: 0 },
        { key: 104, value: 'r', x: 3, y: 0 },
        { key: 105, value: 't', x: 4, y: 0 },
        { key: 106, value: 'y', x: 5, y: 0 },
        { key: 107, value: 'u', x: 6, y: 0 },
        { key: 108, value: 'i', x: 7, y: 0 },
        { key: 109, value: 'o', x: 8, y: 0 },
        { key: 110, value: 'p', x: 9, y: 0 },
        { key: 112, value: 'é', x: 10, y: 0 },
        { key: 111, value: 'Backspace', x: 11, y: 0, width: 2 },

        { key: 200, value: 'q', x: 0.5, y: 1 },
        { key: 201, value: 's', x: 1.5, y: 1 },
        { key: 202, value: 'd', x: 2.5, y: 1 },
        { key: 203, value: 'f', x: 3.5, y: 1 },
        { key: 204, value: 'g', x: 4.5, y: 1 },
        { key: 205, value: 'h', x: 5.5, y: 1 },
        { key: 206, value: 'j', x: 6.5, y: 1 },
        { key: 207, value: 'k', x: 7.5, y: 1 },
        { key: 208, value: 'l', x: 8.5, y: 1 },
        { key: 209, value: 'm', x: 9.5, y: 1 },
        { key: 211, value: 'ù', x: 10.5, y: 1 },
        { key: 210, value: 'Enter', x: 11.5, y: 1, width: 1.5 },

        { key: 300, value: 'Shift', x: 0, y: 2, icon: 'arrow up icon', color: '#1e1d20' },
        { key: 301, value: 'w', x: 1, y: 2 },
        { key: 302, value: 'x', x: 2, y: 2 },
        { key: 303, value: 'c', x: 3, y: 2 },
        { key: 304, value: 'v', x: 4, y: 2 },
        { key: 305, value: 'b', x: 5, y: 2 },
        { key: 306, value: 'n', x: 6, y: 2 },
        { key: 307, value: 'è', x: 7, y: 2 },
        { key: 308, value: 'à', x: 8, y: 2 },
        { key: 309, value: ',', shift: ';', x: 9, y: 2 },
        { key: 310, value: '.', shift: ':', x: 10, y: 2 },
        { key: 312, value: "'", shift: '?', x: 11, y: 2 },
        { key: 311, value: 'Shift', x: 12, y: 2, icon: 'arrow up icon', color: '#1e1d20', width: 1 },

        { key: 400, value: 'Annuleer', x: 0, y: 3, color: '#ff6160', width: 1.5 },
        { key: 401, value: '&123', x: 1.5, y: 3, color: '#1e1d20' },
        { key: 402, value: 'Keyboard', x: 2.5, y: 3, icon: 'keyboard icon', color: '#1e1d20' },
        { key: 403, value: ' ', x: 3.5, y: 3, width: 6 },
        { key: 404, value: 'Left', x: 9.5, y: 3, color: '#1e1d20', icon: 'arrow left icon' },
        { key: 405, value: 'Right', x: 10.5, y: 3, color: '#1e1d20', icon: 'arrow right icon' },
        { key: 406, value: 'Ok', x: 11.5, y: 3, color: '#63be5e', width: 1.5 }
];

// QWERTY
export const QWERTY = [
        { key: 100, value: 'q', x: 0, y: 0 },
        { key: 102, value: 'w', x: 1, y: 0 },
        { key: 103, value: 'e', x: 2, y: 0 },
        { key: 104, value: 'r', x: 3, y: 0 },
        { key: 105, value: 't', x: 4, y: 0 },
        { key: 106, value: 'y', x: 5, y: 0 },
        { key: 107, value: 'u', x: 6, y: 0 },
        { key: 108, value: 'i', x: 7, y: 0 },
        { key: 109, value: 'o', x: 8, y: 0 },
        { key: 110, value: 'p', x: 9, y: 0 },
        { key: 111, value: 'Backspace', x: 10, y: 0, width: 3 },

        { key: 200, value: 'a', x: 0.5, y: 1 },
        { key: 201, value: 's', x: 1.5, y: 1 },
        { key: 202, value: 'd', x: 2.5, y: 1 },
        { key: 203, value: 'f', x: 3.5, y: 1 },
        { key: 204, value: 'g', x: 4.5, y: 1 },
        { key: 205, value: 'h', x: 5.5, y: 1 },
        { key: 206, value: 'j', x: 6.5, y: 1 },
        { key: 207, value: 'k', x: 7.5, y: 1 },
        { key: 208, value: 'l', x: 8.5, y: 1 },
        { key: 209, value: '\'', shift: '"', x: 9.5, y: 1 },
        { key: 210, value: 'Enter', x: 10.5, y: 1, width: 2 },

        { key: 300, value: 'Shift', x: 0, y: 2, icon: 'arrow up icon', color: '#1e1d20' },
        { key: 301, value: 'z', x: 1, y: 2 },
        { key: 302, value: 'x', x: 2, y: 2 },
        { key: 303, value: 'c', x: 3, y: 2 },
        { key: 304, value: 'v', x: 4, y: 2 },
        { key: 305, value: 'b', x: 5, y: 2 },
        { key: 306, value: 'n', x: 6, y: 2 },
        { key: 307, value: 'm', x: 7, y: 2 },
        { key: 308, value: ',', shift: ';', x: 8, y: 2 },
        { key: 309, value: '.', shift: ':', x: 9, y: 2 },
        { key: 310, value: '?', shift: '!', x: 10, y: 2 },
        { key: 311, value: 'Shift', x: 11, y: 2, icon: 'arrow up icon', color: '#1e1d20', width: 2 },

        { key: 400, value: 'Annuleer', x: 0, y: 3, color: '#ff6160', width: 1.5 },
        { key: 401, value: '&123', x: 1.5, y: 3, color: '#1e1d20' },
        { key: 402, value: 'Keyboard', x: 2.5, y: 3, icon: 'keyboard icon', color: '#1e1d20' },
        { key: 403, value: ' ', x: 3.5, y: 3, width: 6 },
        { key: 404, value: 'Left', x: 9.5, y: 3, color: '#1e1d20', icon: 'arrow left icon' },
        { key: 405, value: 'Right', x: 10.5, y: 3, color: '#1e1d20', icon: 'arrow right icon' },
        { key: 406, value: 'Ok', x: 11.5, y: 3, color: '#63be5e', width: 1.5 }
];

// SPECIAL_CHARACTERS
export const SPECIAL_CHARACTERS = [
        { key: 100, value: '!', x: 0.5, y: 0 },
        { key: 101, value: '@', x: 1.5, y: 0 },
        { key: 102, value: '#', x: 2.5, y: 0 },
        { key: 103, value: '$', x: 3.5, y: 0 },
        { key: 104, value: '%', x: 4.5, y: 0 },
        { key: 105, value: '&', x: 5.5, y: 0 },
        { key: 106, value: '1', x: 7.5, y: 0, color: '#585858' },
        { key: 107, value: '2', x: 8.5, y: 0, color: '#585858' },
        { key: 108, value: '3', x: 9.5, y: 0, color: '#585858' },
        { key: 109, value: 'Backspace', icon: 'long arrow left icon', x: 11.5, y: 0, color: '#1e1d20' },

        { key: 200, value: '(', x: 0.5, y: 1 },
        { key: 201, value: ')', x: 1.5, y: 1 },
        { key: 202, value: '-', x: 2.5, y: 1 },
        { key: 203, value: '_', x: 3.5, y: 1 },
        { key: 204, value: '=', x: 4.5, y: 1 },
        { key: 205, value: '+', x: 5.5, y: 1 },
        { key: 206, value: '4', x: 7.5, y: 1, color: '#585858' },
        { key: 207, value: '5', x: 8.5, y: 1, color: '#585858' },
        { key: 208, value: '6', x: 9.5, y: 1, color: '#585858' },
        { key: 209, value: 'Enter', icon: 'clockwise rotated level down icon', x: 11.5, y: 1, color: '#1e1d20' },

        { key: 300, value: '\\', x: 0.5, y: 2 },
        { key: 301, value: ';', x: 1.5, y: 2 },
        { key: 302, value: ':', x: 2.5, y: 2 },
        { key: 303, value: '"', x: 3.5, y: 2 },
        { key: 304, value: '*', x: 4.5, y: 2 },
        { key: 305, value: '/', x: 5.5, y: 2 },
        { key: 306, value: '7', x: 7.5, y: 2, color: '#585858' },
        { key: 307, value: '8', x: 8.5, y: 2, color: '#585858' },
        { key: 308, value: '9', x: 9.5, y: 2, color: '#585858' },
        { key: 309, value: 'Annuleer', x: 11.5, y: 2, color: '#ff6160', icon: 'remove icon' },

        { key: 400, value: '&123', x: 0.5, y: 3, color: '#3caace' },
        { key: 401, value: 'Keyboard', icon: 'keyboard icon', x: 1.5, y: 3, color: '#1e1d20' },
        { key: 402, value: 'Left', icon: 'left arrow icon', x: 2.5, y: 3, color: '#1e1d20' },
        { key: 403, value: 'Right', icon: 'right arrow icon', x: 3.5, y: 3, color: '#1e1d20' },
        { key: 404, value: ' ', x: 4.5, y: 3, width: 2, color: '#1e1d20' },
        { key: 406, value: '0', x: 7.5, y: 3, width: 2, color: '#585858' },
        { key: 408, value: '.', x: 9.5, y: 3 },
        { key: 409, value: 'Ok', x: 11.5, y: 3, color: '#63be5e', icon: 'checkmark icon' }
];



// WEBPACK FOOTER //
// src/constants/Keyboard.js